export default {
  methods: {
    render_bar(data) {
      console.log(data);
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          left: 20,
          bottom: 30,
          right: 20
        },
        xAxis: [
          {
            type: 'category',
            data: data.saleNumProportion ? data.saleNumProportion.filter(v=>v.productCount).map(v=>v.category) : [],
            axisPointer: {
              type: 'shadow'
            },
            axisTick: { show: false },
            axisLabel: {
              color: 'rgb(135,139,160)',
              interval: 0
            },
            axisLine: {
              lineStyle: {
                color: '#e2e2e2'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            show: false,
            axisLabel: {
              color: 'rgb(135,139,160)'
            },
            axisTick: { show: false },
            axisLine: {
              lineStyle: {
                color: '#e2e2e2'
              }
            },
            splitLine: { show: false },
            minInterval: 1
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            data: data.saleNumProportion ? data.saleNumProportion.filter(v=>v.productCount).map(v=>v.productCount) : [],
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#0AAD92' },
                  { offset: 1, color: '#0ADB8B' }]
              },
              barBorderRadius: [5, 5, 0, 0]
            },
            
            barWidth: 20,
            // label: {
            //   show: true,
            //   position: 'top'
            // }
          }
        ],
        dataZoom: {
          type: 'inside',
          start: 0,
          end: data.saleNumProportion && data.saleNumProportion.filter(v=>v.productCount).map(v=>v.productCount).length < 6 ? 100 : 45
        }
      };
      let $instance = this.$echarts.init(this.$refs['bar']);
      $instance.setOption(option);
      $instance.getZr().on('click',params => {
        if(this.menus[1].children[3].children.map(v=>v.name).includes("今年上新产品表现")) {
          this.$router.push({
            path: '/newBehavior'
          })
        }
      });
    }
  }
}